import { inject, Injectable } from '@angular/core';
import {
  ContentRemoteDataModel,
  ContentRemoteDataResultModel,
} from '@libs/cms/models';
import { ProductModel, SearchInputModel } from '@libs/shop/models';
import { CatalogSearchRepositoryService } from '@libs/shared/services';
import { catchError, map, Observable, of } from 'rxjs';

@Injectable()
export class ContentRemoteDataResolverService {
  private readonly itemsPerPage: number = 36;
  private readonly catalogSearchRepository: CatalogSearchRepositoryService = inject(CatalogSearchRepositoryService);

  public resolve(remoteDataConfig: ContentRemoteDataModel): Observable<ContentRemoteDataResultModel> {
    switch (remoteDataConfig.type) {
      case 'product': {
        return this.resolveProductData(remoteDataConfig.payload);
      }
    }
  }

  private resolveProductData(payload: SearchInputModel): Observable<ProductModel[]> {
    // By default, the number of products to be fetched is 12 and this is to low and needs to be increased to 36
    payload.ipp = this.itemsPerPage;

    const searchInput: SearchInputModel = payload;

    if (!searchInput.q) {
      return of([]);
    }

    const skus: string[] = searchInput.q.split(',');

    return this.catalogSearchRepository.search(payload).pipe(
      map(data => {
        // the products need to be sorted in the order of the skus that were configured by the user
        const products: Map<string, ProductModel> = new Map(data.products.map(x => [x.sku, x]));
        const sortedProducts: ProductModel[] = [];

        for (const sku of skus) {
          const product: ProductModel | undefined = products.get(sku);

          if (!product) {
            continue;
          }

          sortedProducts.push(product);
        }

        return sortedProducts;
      }),
      catchError((error: Error) => {
        console.error(error);

        return of([]);
      }),
    );
  }
}
